import { createI18n } from "vue-i18n";
import custom_build from "../../custom_build.json";
import reports_dictionary from "../../modules/report/reports/dictionary.json";
import { merge } from "lodash";

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    // console.log(key); // ./en.json, ./es.json ....
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      // messages[locale] = locales(key);
      let merged = merge(
        custom_build.dictionaries[locale] || {},
        locales(key),
        reports_dictionary[locale] || {}
      );
      messages[locale] = merged;
      // console.log("v1", v1, "v2", v2, "merged", merged);
    }
  });
  // console.log(messages);
  return messages;
}

export default createI18n({
  locale: "es",
  fallbackLocale: "en",
  messages: loadLocaleMessages(),
});
